import { render, staticRenderFns } from "./join-status.vue?vue&type=template&id=2923bc1e&scoped=true&"
import script from "./join-status.vue?vue&type=script&lang=js&"
export * from "./join-status.vue?vue&type=script&lang=js&"
import style0 from "./join-status.vue?vue&type=style&index=0&id=2923bc1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2923bc1e",
  null
  
)

export default component.exports